import { __ } from '@oat-sa-private/ui-core';
import { tabKeys } from '@/core/utils/consts';

/**
 * Returns ribbon presets collection. Each presents contains
 * data that will be sent to Ribbon LDS component.
 * @activeTab param is required for dynamic tab
 * dependant property values
 * @param {string} activeTab - current active tab
 * @returns {object} - collection of available presets
 */
export function getPresets(activeTab) {
    return {
        'internetConnection.detected': {
            message: __('No internet connection. Trying to reconnect.'),
            icon: '',
            type: 'loading'
        },
        'internetConnection.failure': {
            message: __('No internet connection. Please verify your connection or contact your system administrator.'),
            icon: 'warning-16',
            type: 'warning'
        },
        'ws.detected': {
            message: __('Unable to update test taker progress. Trying to reconnect.'),
            icon: '',
            type: 'loading'
        },
        'ws.failure': {
            message: __('Unable to update test taker progress. Please restart proctoring or contact your system administrator.'),
            icon: 'warning-16',
            type: 'warning'
        },
        'nrps.detected': {
            message: activeTab === tabKeys.notStarted ? __('Attendance list could not be loaded. Trying to reload.') : __('Test taker information could not be loaded. Trying to reload.'),
            icon: '',
            type: 'loading'
        },
        'nrps.failure': {
            message:
                activeTab === tabKeys.notStarted
                    ? __('Unable to load attendance list. Please restart proctoring or contact your system administrator.')
                    : __('Unable to load test taker information. Please restart proctoring or contact your system administrator.'),
            icon: 'warning-16',
            type: 'warning'
        },
        'interactions.detected': {
            message: __('Test sessions could not be loaded. Trying to reload.'),
            icon: '',
            type: 'loading'
        },
        'interactions.failure': {
            message: __('Unable to load test sessions. Please restart proctoring. If the problem persists contact your system administrator.'),
            icon: 'warning-16',
            type: 'warning'
        },
        'multiCause.failure': {
            message: __('Unexpected errors occurred. Please restart proctoring. If the problem persists, contact your system administrator.'),
            icon: 'warning-16',
            type: 'warning'
        }
    };
}
